module.exports = __webpack_public_path__ + "img/numberEle.06598034.svg";